import { ActivitySpinnerSize, ActivitySpinnerWidget, ButtonProps, ButtonWidget } from '@tableau/widgets';
import { ButtonAttrs } from '@tableau/widgets/lib/src/utils/HtmlAttrs';
import * as React from 'react';

const spinnerStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

/**
 * A button with an optional spinner shown within it. Used for action dialogs and the like.
 * When shown, the spinner appears in place of the button text, as specified in the
 * design guidelines: http://design/guidelines/components/activity-spinner
 */
function ButtonWithSpinnerComponent(props: ButtonWithSpinnerProps & Omit<ButtonProps, 'handleClick' | 'style'> & ButtonAttrs): JSX.Element {
  const buttonStyle: React.CSSProperties = {
    verticalAlign: 'top',
    ...props.styleOverrides,
  };

  const {showSpinner, clicked, title, onDarkBackground, styleOverrides, ...childProps} = props;
  return (
    <ButtonWidget
      handleClick = {props.clicked}
      style = {buttonStyle}
      {...childProps}
    >
      <div style={{ position: 'relative' }}>
        <span className="buttonWithSpinnerTitle" style={{ visibility: props.showSpinner ? 'hidden' : 'visible' }}>
          {props.title}
        </span>
        { props.showSpinner ? <SuperimposedSpinner onDarkBackground={props.onDarkBackground} /> : null }
      </div>
    </ButtonWidget>
  );
}

function SuperimposedSpinner(props: { onDarkBackground?: boolean }): JSX.Element {
  return (
    <div style={spinnerStyle}>
      <ActivitySpinnerWidget
        spinnerSize = {ActivitySpinnerSize.Small}
        testId= {'button-icon-spinner'}
        onDarkBackground = {props.onDarkBackground}
      />
    </div>
  );
}

export const ButtonWithSpinner = React.memo(ButtonWithSpinnerComponent);

export interface ButtonWithSpinnerProps {
  readonly showSpinner?: boolean;
  /**
   * @deprecated instead use `onClick`
   */
  readonly clicked?: () => void;
  readonly disabled?: boolean;
  readonly title?: string;
  readonly testId: string;
  readonly onDarkBackground?: boolean;
  readonly styleOverrides?: React.CSSProperties;
}
